import React, {useContext} from 'react';
const AuthUserContext =React.createContext();

export const useAuth = () => {
	return useContext(AuthUserContext)
} 

export default AuthUserContext;